import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { IonItem } from '@ionic/angular/standalone';

@Component({
  selector: 'crowdctrl-item',
  standalone: true,
  imports: [CommonModule, IonItem],
  templateUrl: './item.component.html',
  styleUrl: './item.component.css',
})
export class ItemComponent {
  @Input() button = false;
  @Input() detail = false;
  @Input() lines: 'full' | 'none' | 'inset' = 'full';
  @Input() itemClass?: string;

  get hostClassString(): string {
    const parts: string[] = ['crowdctrl-item'];
    const extra = this.itemClass?.trim();
    if (extra) {
      parts.push(extra);
    }
    return parts.join(' ');
  }
}
